module.exports = __webpack_public_path__ + "src/assets/textures/molar/spoon1.jpg";